import { CLIENTDETAILS, CLIENTDETAILS_ERROR, CLIENTDETAILS_HIDE_ERROR, CLIENTDETAILS_START_LOADER, CLIENTDETAILS_STOP_LOADER } from "../interface/IClientDetails";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const ClientDetailsReducer = (state = initState, action) => {
    switch (action.type) {
        case CLIENTDETAILS:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case CLIENTDETAILS_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case CLIENTDETAILS_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case CLIENTDETAILS_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case CLIENTDETAILS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default ClientDetailsReducer;
